import React from 'react';
import styled from 'styled-components';
import { tok } from './styles';

/**
 * Icon bullet list used by both the instructions "Step-by-Step Process" and the
 * result totals — replaces the DS `BulletList` (whose icon font lacks the source
 * glyphs). Matches the live layout: 20px icon top-aligned, title 16/600, then a
 * 16/400 description; ~20px between items.
 */
export type IconListItem = {
  icon: React.ReactNode;
  title: React.ReactNode;
  description: React.ReactNode;
};

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Item = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

const IconCol = styled.span`
  flex-shrink: 0;
  width: 20px;
  height: 24px;
  display: inline-flex;
  align-items: center;
`;

const Title = styled.div`
  margin-bottom: 4px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: ${({ theme }) => tok(theme, 'general_font_primary', '#1E1E1E')};
`;

const Desc = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: ${({ theme }) => tok(theme, 'general_font_primary', '#1E1E1E')};
`;

export const IconList: React.FC<{ items: IconListItem[] }> = ({ items }) => (
  <List>
    {items.map((it, i) => (
      <Item key={i}>
        <IconCol>{it.icon}</IconCol>
        <div>
          <Title>{it.title}</Title>
          <Desc>{it.description}</Desc>
        </div>
      </Item>
    ))}
  </List>
);
